/**
 * pages.config.js - Page routing configuration
 * 
 * This file is AUTO-GENERATED. Do not add imports or modify PAGES manually.
 * Pages are auto-registered when you create files in the ./pages/ folder.
 * 
 * THE ONLY EDITABLE VALUE: mainPage
 * This controls which page is the landing page (shown when users visit the app).
 * 
 * Example file structure:
 * 
 *   import HomePage from './pages/HomePage';
 *   import Dashboard from './pages/Dashboard';
 *   import Settings from './pages/Settings';
 *   
 *   export const PAGES = {
 *       "HomePage": HomePage,
 *       "Dashboard": Dashboard,
 *       "Settings": Settings,
 *   }
 *   
 *   export const pagesConfig = {
 *       mainPage: "HomePage",
 *       Pages: PAGES,
 *   };
 * 
 * Example with Layout (wraps all pages):
 *
 *   import Home from './pages/Home';
 *   import Settings from './pages/Settings';
 *   import __Layout from './Layout.jsx';
 *
 *   export const PAGES = {
 *       "Home": Home,
 *       "Settings": Settings,
 *   }
 *
 *   export const pagesConfig = {
 *       mainPage: "Home",
 *       Pages: PAGES,
 *       Layout: __Layout,
 *   };
 *
 * To change the main page from HomePage to Dashboard, use find_replace:
 *   Old: mainPage: "HomePage",
 *   New: mainPage: "Dashboard",
 *
 * The mainPage value must match a key in the PAGES object exactly.
 */
import { lazy } from 'react';
// Home is loaded eagerly (landing page) for fastest first paint.
import Home from './pages/Home';
import __Layout from './Layout.jsx';

// All other pages are code-split — only fetched when the user visits them.
const About = lazy(() => import('./pages/About'));
const Affiliate = lazy(() => import('./pages/Affiliate'));
const Blog = lazy(() => import('./pages/Blog'));
const BlogPost = lazy(() => import('./pages/BlogPost'));
const Checkout = lazy(() => import('./pages/Checkout'));
const CheckoutBeadBreakerArm = lazy(() => import('./pages/CheckoutBeadBreakerArm'));
const CheckoutSparePart = lazy(() => import('./pages/CheckoutSparePart'));
const Contact = lazy(() => import('./pages/Contact'));
const DomainSetup = lazy(() => import('./pages/DomainSetup'));
const HowToUse = lazy(() => import('./pages/HowToUse'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const Product = lazy(() => import('./pages/Product'));
const RefundPolicy = lazy(() => import('./pages/RefundPolicy'));
const ResearchKeywords = lazy(() => import('./pages/ResearchKeywords'));
const ShippingPolicy = lazy(() => import('./pages/ShippingPolicy'));
const SparePartBeadBreakerArm = lazy(() => import('./pages/SparePartBeadBreakerArm'));
const SparePartHubAssembly = lazy(() => import('./pages/SparePartHubAssembly'));
const SpareParts = lazy(() => import('./pages/SpareParts'));
const TransportationFee = lazy(() => import('./pages/TransportationFee'));
const Upload3DModel = lazy(() => import('./pages/Upload3DModel'));
const WarrantyPolicy = lazy(() => import('./pages/WarrantyPolicy'));
const home = lazy(() => import('./pages/home'));
const DataExport = lazy(() => import('./pages/DataExport'));


export const PAGES = {
    "About": About,
    "Affiliate": Affiliate,
    "Blog": Blog,
    "BlogPost": BlogPost,
    "Checkout": Checkout,
    "CheckoutBeadBreakerArm": CheckoutBeadBreakerArm,
    "CheckoutSparePart": CheckoutSparePart,
    "Contact": Contact,
    "DomainSetup": DomainSetup,
    "Home": Home,
    "HowToUse": HowToUse,
    "PrivacyPolicy": PrivacyPolicy,
    "Product": Product,
    "RefundPolicy": RefundPolicy,
    "ResearchKeywords": ResearchKeywords,
    "ShippingPolicy": ShippingPolicy,
    "SparePartBeadBreakerArm": SparePartBeadBreakerArm,
    "SparePartHubAssembly": SparePartHubAssembly,
    "SpareParts": SpareParts,
    "TransportationFee": TransportationFee,
    "Upload3DModel": Upload3DModel,
    "WarrantyPolicy": WarrantyPolicy,
    "home": home,
    "DataExport": DataExport,
}

export const pagesConfig = {
    mainPage: "Home",
    Pages: PAGES,
    Layout: __Layout,
};